import PriceSegmentsPicker from '@/components/Feed/PriceSegments/PriceSegmentsPicker'
import { getPartnerSegmentHint } from '@/components/Feed/PriceSegments/priceSegmentsTexts'
import SegmentPriceValue from '@/components/Feed/PriceSegments/SegmentPriceValue'
import PriceUnavailable from '@/components/Feed/PriceUnavailable/PriceUnavailable'
import UpdatedAtTooltip from '@/components/Feed/UpdatedAtTooltip/UpdatedAtTooltip'
import { useFeedPriceSegments } from '@/hooks/search/useFeedPriceSegments'
import { useUserInfoStore } from '@/stores/user/userInfoStore'
import type { OfferPriceType, SegmentShortModel } from '@/types'
import { formatPriceWithVat } from '@/utils/price/vat'

import cn from '../ProductCard.module.scss'

interface SegmentPriceProps {
  price: OfferPriceType | undefined
  isHidden: boolean
  showPicker?: boolean
  partnerSegment?: SegmentShortModel
}

function SegmentPrice({
  price,
  isHidden,
  showPicker = false,
  partnerSegment,
}: SegmentPriceProps) {
  const contextSegment = useUserInfoStore((state) => state.contextSegment)
  const selectedSegments = useFeedPriceSegments()
  const sellingPrice = price?.sellingPrice

  const renderMain = () => {
    if (isHidden) return '*** BYN'
    if (sellingPrice === undefined) return <PriceUnavailable price={price} />
    return (
      <UpdatedAtTooltip
        updatedAt={price?.priceUpdatedAt}
        kind="price"
        priceSource={price?.priceSource}
      >
        {formatPriceWithVat(sellingPrice)} BYN
      </UpdatedAtTooltip>
    )
  }

  const renderSegmentValue = (segmentCode: number) => {
    if (isHidden) return '*** BYN'
    if (!price?.segmentPrices)
      return partnerSegment
        ? getPartnerSegmentHint(partnerSegment.description)
        : '—'
    return (
      <SegmentPriceValue
        segmentPrice={price.segmentPrices.find(
          (item) => item.segmentCode === segmentCode
        )}
        contextPrice={sellingPrice}
        suffix=" BYN"
      />
    )
  }

  return (
    <div className={cn.cell}>
      {showPicker && contextSegment && (
        <PriceSegmentsPicker
          className={cn.segmentPicker}
          label={`Цена по сегменту · ${contextSegment.description}`}
        />
      )}
      {renderMain()}
      {selectedSegments.length > 0 && (
        <ul className={cn.segmentPrices}>
          {selectedSegments.map((segment) => (
            <li key={segment.code}>
              {segment.description} — {renderSegmentValue(segment.code)}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default SegmentPrice
